import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Dev-only: open http://localhost:3000/#sim-dev to preview the pump simulator
// without logging in. `process.env.NODE_ENV` is baked in at build time, so
// this branch is removed from production builds entirely (REACT_APP_SIM_PREVIEW=1
// re-enables it for local performance testing of a production build only).
let Root = App;
if ((process.env.NODE_ENV === 'development' || process.env.REACT_APP_SIM_PREVIEW === '1') && window.location.hash === '#sim-dev') {
  const SimScreen = React.lazy(() => import('./sim/SimScreen').then((m) => ({ default: m.SimScreen })));
  Root = () => (
    <div style={{ maxWidth: 1600, margin: '0 auto', padding: '20px 14px', background: '#0b0d0f', minHeight: '100vh', boxSizing: 'border-box' }}>
      <React.Suspense fallback={null}><SimScreen /></React.Suspense>
    </div>
  );
}

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// Unregister old service worker so deploys take effect immediately
serviceWorkerRegistration.unregister();

reportWebVitals();
